// extracted by mini-css-extract-plugin
export default {"linkPath":"Custom_linkPath__cCstO"};